"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const Utils_1 = __importDefault(require("./utilities/Utils"));
/**
 * Formatters / Parsers for 'Moment' date objects
 */
class Formatter {
    static get nowDate() {
        return (0, moment_1.default)().date(1).hour(0).minute(0).second(0).millisecond(0);
    }
    static discardDatePrecision(momentDate) {
        return momentDate.date(1).hour(0).minute(0).second(0).millisecond(0);
    }
    /**
     * Format to display dates on screen.
     * @returns {string}
     */
    static get displayFormat() {
        return 'Do MMMM YYYY';
    }
    static get monthOnlyDisplayFormat() {
        return 'MMMM YYYY';
    }
    static get shortMonthOnlyDisplayFormat() {
        return 'MMM YY';
    }
    static get shortMonthFullYearDisplayFormat() {
        return 'MMM YYYY';
    }
    static get dayShortMonthFullYearDisplayFormat() {
        return 'DD MMM yyyy';
    }
    static get serverFormat() {
        return 'YYYY-MM-DD HH:mm';
    }
    static get serverDateFormat() {
        return 'YYYY-MM-DD';
    }
    static get yearMonthFormat() {
        return 'YYYY-MM';
    }
    static get graphDateFormat() {
        return 'MMM-YY';
    }
    static get fullMonthNameFormat() {
        return 'MMMM';
    }
    static get shortenedMonthNameFormat() {
        return 'MMM';
    }
    static get monthNumberFormat() {
        return 'M';
    }
    /**
     * Moment object to ISO string
     * @param value {Moment}
     * @returns {string|*}
     */
    static momentToServerFormat(value) {
        return value.format(Formatter.serverFormat);
    }
    static momentToServerDateFormat(value) {
        return value.format(Formatter.serverDateFormat);
    }
    /**
     * Moment object to Display format
     * @param value {Moment}
     * @returns {string|*}
     */
    static momentToDisplayFormat(value) {
        return value.format(Formatter.displayFormat);
    }
    static momentToMonthOnlyDisplayFormat(value) {
        return value.format(Formatter.monthOnlyDisplayFormat);
    }
    static monthOnlyToMoment(str) {
        return (0, moment_1.default)(str, Formatter.monthOnlyDisplayFormat);
    }
    /**
     * String in Display Format to Server required string
     * @param string {string}
     * @returns {string|*}
     */
    static toServerFormat(str) {
        return (0, moment_1.default)(str, Formatter.displayFormat).format(Formatter.serverFormat); // Y-M-DTH:M:SZZ
    }
    /**
     * String in Server Format to Display Format
     * @param value {string}
     * @returns {*}
     */
    static toDisplayFormat(str) {
        return Formatter.serverFormatToMoment(str).format(Formatter.displayFormat);
    }
    static toDisplayMonthOnlyFormat(str) {
        return Formatter.serverFormatToMoment(str).format(Formatter.monthOnlyDisplayFormat);
    }
    static toDisplayShortMonthOnlyFormat(str) {
        return Formatter.serverFormatToMoment(str).format(Formatter.shortMonthOnlyDisplayFormat);
    }
    static displayFormatToMoment(str) {
        return (0, moment_1.default)(str, Formatter.displayFormat);
    }
    static serverFormatToMoment(str) {
        return (0, moment_1.default)(str, Formatter.serverFormat);
    }
    static serverDateFormatToMoment(str) {
        return (0, moment_1.default)(str, Formatter.serverDateFormat);
    }
    static negativeToParentheses(num) {
        const formatted = Math.abs(num).toFixed(2);
        if (num < 0) {
            return `(${formatted})`;
        }
        return formatted;
    }
    static isNaNOrInfinity(val) {
        return val === Infinity || isNaN(val);
    }
    static roundNumberWithCommas(num) {
        if (Formatter.isNaNOrInfinity(num)) {
            return ' - ';
        }
        return Formatter.numberWithCommas(Math.round(num));
    }
    static numberWithCommas(num) {
        const isNegative = num < 0;
        const absValue = Math.abs(num);
        const formattedValue = Utils_1.default.removePrecisionAndGetCommas(absValue);
        return isNegative
            ? `(${formattedValue})`
            : formattedValue;
    }
    static toPercent(num) {
        if (Formatter.isNaNOrInfinity(num)) {
            return ' - ';
        }
        const isNegative = num < 0;
        const formattedValue = `${(Math.abs(num * 100)).toFixed(2)}%`;
        return isNegative
            ? `(${formattedValue})`
            : formattedValue;
    }
    static toDecimal(num) {
        if (Formatter.isNaNOrInfinity(num)) {
            return ' - ';
        }
        return Formatter.negativeToParentheses(num);
    }
}
exports.default = Formatter;
